@if(isDealerOpeningHoursValid) {
  <div class="opening-hour">
    <p>{{'schedule.attendance-hour' | translate}}</p>
    <p>{{'schedule.office-hours-during-week' | translate : {minHour: dealer().lowestTimeWeek, maxHour: dealer().highestTimeWeek} }}</p>

    @if (dealer().openSaturday) {
      <p>{{'schedule.office-hours-during-saturday' | translate : {minHour: dealer().lowestTimeWeekend, maxHour: dealer().highestTimeWeekend} }}</p>
    }
    @if (dealer().openSunday) {
      <p>{{'schedule.office-hours-during-sunday' | translate : {minHour: dealer().lowestTimeWeekend, maxHour: dealer().highestTimeWeekend} }}</p>
    }
  </div>
}
